import React from 'react';

import FullPageModalIFramaContent from 'src/presentation/components/pages/glados/components/FullPageModalIFramaContent';

const ActionAdapterEditor = ({ id, root }) => {
  return <FullPageModalIFramaContent root={root} srcPath={`/${id}`} />;
};

export default ActionAdapterEditor;
